import React from 'react'

const StopShareScreen = ({
  fill = 'black',
  width
}: {
  fill?: string
  width?: string
}) => (
  <svg
    width={width || '24px'}
    height={width || '24px'}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 18H3.5C2.4 18 1.5 17.11 1.5 16V4C1.5 2.89 2.39 2 3.5 2H21.5C22.6 2 23.5 2.89 23.5 4V16C23.5 17.11 22.61 18 21.5 18H13.5V20H16.5V22H8.5V20H11.5V18ZM3.5 16H21.5V4H3.5V16ZM16.207 7.70703L13.9141 10L16.207 12.293L14.793 13.707L12.5 11.4141L10.207 13.707L8.79297 12.293L11.0859 10L8.79297 7.70703L10.207 6.29297L12.5 8.58594L14.793 6.29297L16.207 7.70703Z"
      fill={fill}
    />
  </svg>
)

export default StopShareScreen
